import React, { useState } from 'react';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';
import MagicForm from '../../../../Components/Form/MagicForm';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import moment, { Moment } from 'moment';
import { v4 as uuidv4 } from 'uuid';
// @ts-ignore
import styles from './ElectronicPrescriptionPolandAddMedicamentForm.module.scss';
import Loading from '../../../../Components/Loading';

interface ElectronicPrescriptionPolandFormRawValues {
	medicament: SelectValue;
	paymentCoverage: SelectValue;
	medicamentChange: boolean;
	validFrom: Moment;
	recipeRepeat: number;
	amountOfPackages: number;
	dosageCount: number;
	dosageInterval: SelectValue;
	dosageIntervalCustom?: number;
}

export interface ElectronicPrescriptionPolandFormValues
	extends ElectronicPrescriptionPolandFormRawValues {
	id: string;
}

interface Props {
	onSubmit: (values: ElectronicPrescriptionPolandFormValues) => void;
}

const FORM_SCHEME: ItemScheme[] = [
	{
		type: MagicField.HSTACK,
		children: [
			{
				type: MagicField.P1_MEDICAMENT,
				key: 'medicament',
				title: 'component.electronicPrescriptionPoland.medicament',
				settings: {
					required: true,
				},
			},
			{
				type: MagicField.DATEPICKER,
				key: 'validFrom',
				title: 'component.electronicPrescriptionPoland.validFrom',
			},
			{
				type: MagicField.P1_PAYMENT_COVERAGE_TYPE,
				key: 'paymentCoverage',
				title: 'component.electronicPrescriptionPoland.paymentCoverage',
				settings: {
					required: true,
					useTermItemValue: true,
				},
			},
		],
	},
	{
		type: MagicField.HSTACK,
		children: [
			{
				type: MagicField.TEXT_FIELD,
				subType: 'number',
				key: 'recipeRepeat',
				title: 'component.electronicPrescriptionPoland.recipeRepeat',
				settings: {
					required: false,
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				subType: 'number',
				key: 'amountOfPackages',
				title: 'component.electronicPrescriptionPoland.amountOfPackages',
				settings: {
					required: true,
				},
			},
			{
				type: MagicField.TEXT_FIELD,
				subType: 'number',
				key: 'dosageCount',
				title: 'component.electronicPrescriptionPoland.dosageCount',
				settings: {
					required: true,
				},
			},
			{
				type: MagicField.P1_DOSAGE_INTERVAL_TYPE,
				subType: 'number',
				key: 'dosageInterval',
				title: 'component.electronicPrescriptionPoland.dosageInterval',
				settings: {
					required: true,
				},
			},
			{
				type: MagicField.CONDITION,
				value: 'view',
				settings: {
					rules: [
						{
							formControlKey: 'dosageInterval',
							rule: 'equal',
							value: 'custom',
						},
					],
				},
				children: [
					{
						type: MagicField.TEXT_FIELD,
						subType: 'number',
						key: 'dosageIntervalCustom',
						title:
							'component.electronicPrescriptionPoland.dosageIntervalCustom',
						settings: {
							required: true,
							rules: [
								{
									type: 'min',
									value: 1,
									message:
										'component.electronicPrescriptionPoland.dosageIntervalCustomValidationMessage',
								},
								{
									type: 'max',
									value: 24,
									message:
										'component.electronicPrescriptionPoland.dosageIntervalCustomValidationMessage',
								},
							],
						},
					},
				],
			},
		],
	},
	{
		type: MagicField.CHECKBOX,
		key: 'medicamentChange',
		title: 'component.electronicPrescriptionPoland.medicamentChange',
		settings: {
			required: false,
		},
	},
];

const DEFAULT_VALUES = {
	validFrom: moment(),
	medicamentChange: false,
};

const ElectronicPrescriptionPolandAddMedicamentForm: React.FC<Props> = ({
	onSubmit,
}) => {
	const [isLoading, setIsLoading] = useState(false);

	const handleSubmit = (vals: ElectronicPrescriptionPolandFormRawValues) => {
		setIsLoading(true);
		const id = uuidv4();
		const values: ElectronicPrescriptionPolandFormValues = { ...vals, id };
		onSubmit(values);
		setIsLoading(false);
	};

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<MagicForm
				formScheme={FORM_SCHEME}
				onSubmit={handleSubmit}
				defaultValues={DEFAULT_VALUES}
				submitText='component.electronicPrescriptionPoland.addMedicament'
			/>
		</div>
	);
};

export default ElectronicPrescriptionPolandAddMedicamentForm;
